import React from 'react';
import styled from 'styled-components';

export default function Duration({ className, seconds }) {
  return (
    <Time dateTime={`P${Math.round(seconds)}S`} className={className}>
      {format(seconds)}
    </Time>
  );
}

const Time = styled.time`
  min-width: 2.25rem;
  font-size: 0.75rem;
  margin: 0 0.25rem;
  text-align: center;
  flex-shrink: 0;
  color: #999;
`;

function format(seconds) {
  const date = new Date(seconds * 1000);
  const hh = date.getUTCHours();
  const mm = date.getUTCMinutes();
  const ss = pad(date.getUTCSeconds());
  if (hh) {
    return `${hh}:${pad(mm)}:${ss}`;
  }
  return `${mm}:${ss}`;
}

function pad(string) {
  return ('0' + string).slice(-2);
}



// WEBPACK FOOTER //
// ./src/components/Duration/Duration.js